import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import { includes, trimEnd } from 'lodash';
import { useLocation } from 'react-router-dom';
import { Footer, NavBar } from '../../components';

export const AuthLayout = () => {
  const location = useLocation();
  const showNavBar = !includes(['/auth/sign_in', '/auth/register', '/auth/thank_you'], trimEnd(location.pathname, '/'));

  return (
    <Box display="flex" height="100svh" flexDirection="column">
      <NavBar hideNavBar={!showNavBar} />
      <Outlet />

      <div style={{ flexGrow: 1 }} />

      <Footer />
    </Box>
  );
};
